import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserData, DealerAttachmentDetails } from 'src/app/Models/app-data';

@Injectable({
    providedIn: 'root'
})
export class FormsService {

    //#region Global Variables
    _apiURL: string = "../api/Form/";
    //#endregion

    constructor(private http: HttpClient) { }


    validateRego(regoNumber: string): Observable<any> {
        //return this.http.get(this._apiURL + 'ValidateRego/' + regoNumber);
        return this.http.post(this._apiURL + 'ValidateRego', JSON.stringify(regoNumber), {
            headers: { 'Content-Type': 'application/json' }
        });
    }
    submitForm(submitData: any): Observable<any> {
        return this.http.post(this._apiURL + 'SubmitStocktake', submitData);
    }
    
    getAllActiveUsersList(): Observable<any> {
        return this.http.get(this._apiURL + "GetAllActiveUsersList");
    }


    getDefaultValues(): Observable<any> {
        return this.http.get(this._apiURL + "GetDefaultValues");
    }

    validateCredentials(username: string, password: string): Observable<any> {
        return this.http.post(this._apiURL+'validate', { username, password });
    }
}
